export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'star',
    name: '明星爆料',
    description: '最新最全的娱乐圈明星动态、绯闻八卦、恋情曝光等一线资讯',
    icon: 'ri-star-line',
    articleCount: 1256,
  },
  {
    slug: 'influencer',
    name: '网红吃瓜',
    description: '头部网红、主播、UP主的实时动态与争议事件追踪报道',
    icon: 'ri-user-smile-line',
    articleCount: 987,
  },
  {
    slug: 'social',
    name: '社会热点',
    description: '紧跟时事的娱乐圈相关社会事件深度分析与独家解读',
    icon: 'ri-fire-line',
    articleCount: 754,
  },
  {
    slug: 'competition',
    name: '每日大赛',
    description: '每日最热门吃瓜话题PK，参与投票选出今日最劲爆爆料',
    icon: 'ri-trophy-line',
    articleCount: 432,
  },
  {
    slug: 'video',
    name: '51吃瓜视频',
    description: '热门吃瓜事件视频合集，高清在线观看最新爆料现场',
    icon: 'ri-video-line',
    articleCount: 621,
  },
];